import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { SITE_NAME, SITE_TAGLINE } from '../../constants';
import { useAuth } from '../../hooks/useAuth';

export const AuthLayout: React.FC = () => {
  const { user, loading } = useAuth();

  // Usuário já autenticado → redirecionar
  if (!loading && user) {
    // Consumir flag de onboarding pós-signup pra rotear ao picker de planos
    let redirectTo = '/dashboard';
    try {
      if (localStorage.getItem('pending_onboarding') === '1') {
        localStorage.removeItem('pending_onboarding');
        redirectTo = '/onboarding/plans';
      }
    } catch {
      // localStorage indisponível — fallback /dashboard
    }
    return <Navigate to={redirectTo} replace />;
  }

  return (
    <div className="min-h-dvh bg-neutral-950 flex flex-col items-center justify-center px-4">
      {/* Background blobs */}
      <div className="fixed inset-0 z-0 overflow-hidden pointer-events-none">
        <div
          className="absolute top-[-10%] right-[-10%] w-[500px] h-[500px] bg-blue-600/10 rounded-full blur-[100px]"
          style={{ animation: 'floatBlob 15s ease-in-out infinite' }}
        />
        <div
          className="absolute bottom-[-20%] left-[-5%] w-[400px] h-[400px] bg-purple-600/10 rounded-full blur-[80px]"
          style={{ animation: 'floatBlob 20s ease-in-out infinite reverse' }}
        />
      </div>

      <div className="relative z-10 w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-8">
          <img
            src="/one-form-logo/SVG/favicon-one-form.svg"
            alt={SITE_NAME}
            className="h-12 w-12 mx-auto mb-4"
          />
          <h1 className="text-2xl font-bold text-white">{SITE_NAME}</h1>
          <p className="text-neutral-400 text-sm mt-1">{SITE_TAGLINE}</p>
        </div>

        <Outlet />

        {/* Footer */}
        <p className="text-center text-neutral-500 text-sm mt-8">
          &copy; {new Date().getFullYear()} {SITE_NAME}
        </p>
      </div>
    </div>
  );
};
